//#region IMPORT
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
/** Services Import */
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
/** Components */
import 'dayjs/locale/ko';
import useDelete from '../../../../hooks/useDeleteN';
import {
  useSearch1,
  useSearch2,
  useDelete1,
  useSave1,
  useSave2,
} from './HEA_BASIC_02_QUERY';
import MemberInfoModal from '../../../../Components/MemberInfoModal/MemberInfoModal';
/** Icons Import */
import HEA_BASIC_02 from './HEA_BASIC_02';
import usePartialRefresh from '../../../../hooks/usePartialRefresh';
import { useSave } from '../../../../hooks/useSaveN';
import { HEA_BASIC_02_Schema } from './HEA_BASIC_02_Schema';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';
import {
  closeLoading as closeLoadingAction,
  showLoading as showLoadingAction,
} from '../../../../Reducer/LoadingReducer';
import { setFileFields } from '../../../../Reducer/FileFieldReducer';
import useFileUpload from '../../../../hooks/useFileUpload';
import dayjs from 'dayjs';
import ExcelJS from 'exceljs';
//#endregion

//#region 상수
// 화면 MENU_ID
const SCREEN_MENU_ID = 'HealthCheckup';
//#endregion

function HEA_BASIC_02F(props) {
  //#region 변수
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo, lanInfo, companyInfo } = useSelector(
    (state) => state.BaseInfo
  );
  const { previewUrl, previewFileName } = useSelector(
    (state) => state.fileField
  ); // 미리보기 상태관리
  const searchInfo = useSelector((state) => state.SearchInfo);
  const gridRef1 = useRef(); //특수건강진단 그리드
  const gridRef3 = useRef(); //엑셀 업로드 그리드
  const fileInputRef = useRef(null);

  const [rowData1, setRowData1] = useState([]); //그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]);
  const [changedRowData1, setChangedRowData1] = useState([]);
  const [deletedRows, setDeletedRowData1] = useState([]);
  const selectedRowNosRef1 = useRef(new Set());
  const lastCheckedIndexRef1 = useRef(null);
  const currentRowIndexRef1 = useRef(null);

  // 파일 업로드 관련 상태
  const [fileModalToggle, setFileModalToggle] = useState(false);
  const [currentFileFieldType, setCurrentFileFieldType] =
    useState('hcCheckupFile'); // 'hcCheckupFile' or 'hcPostcareFile'

  // 모달 관련 상태
  const [modalToggle1, setModalToggle1] = useState(false);
  const rowClickData = useRef(null);
  const [excelData, setExcelData] = useState([]);
  //#endregion

  //#region 커스텀훅
  // 회사/거래처 선택 상태 관리 및 필수 여부 검증을 위한 Hook
  const { handleCoChange, handleCustChange, validateSelection } =
    useCompanyCustDep({ requireCompany: true, requireCust: true });

  // 검진표 첨부 파일용 useFileUpload
  const {
    SaveLogicPreview: SaveLogicPreviewCheckup,
    SaveLogicFile: SaveLogicFileCheckup,
    DeleteLogicFile: DeleteLogicFileCheckup,
  } = useFileUpload({
    oldFilePathField: 'hcCheckupAttachmentFilePath',
    newFileNameField: 'hcCheckupAttachmentSaveName',
    getTargetPath: () =>
      `HealthCheckup/${searchInfo.custCd}/HEA_BASIC_02/Checkup`,
  });

  // 사후관리조치 첨부 파일용 useFileUpload
  const {
    SaveLogicPreview: SaveLogicPreviewPostcare,
    SaveLogicFile: SaveLogicFilePostcare,
    DeleteLogicFile: DeleteLogicFilePostcare,
  } = useFileUpload({
    oldFilePathField: 'hcPostcareAttachmentFilePath',
    newFileNameField: 'hcPostcareAttachmentSaveName',
    getTargetPath: () =>
      `HealthCheckup/${searchInfo.custCd}/HEA_BASIC_02/PostCare`,
  });

  // 현재 선택된 파일 필드에 따라 적절한 함수 반환 (기존 호환성 유지)
  const SaveLogicPreview =
    currentFileFieldType === 'hcCheckupFile'
      ? SaveLogicPreviewCheckup
      : SaveLogicPreviewPostcare;
  // eslint-disable-next-line no-unused-vars
  const SaveLogicFile =
    currentFileFieldType === 'hcCheckupFile'
      ? SaveLogicFileCheckup
      : SaveLogicFilePostcare;
  const DeleteLogicFile =
    currentFileFieldType === 'hcCheckupFile'
      ? DeleteLogicFileCheckup
      : DeleteLogicFilePostcare;

  // 부분 갱신 처리 (성공한 데이터만 재조회, 실패한 데이터는 유지)
  const { handlePartialRefresh } = usePartialRefresh({
    gridRef: gridRef1,
    changedRowData: changedRowData1,
    setChangedRowData: setChangedRowData1,
    setRowData: setRowData1,
    getKeyFromRow: (row) => row.hscCd,
    getKeyFromResult: (result) => result.HSC_CD,
  });

  // 파일 필드 타입별 필드명 반환 헬퍼 함수
  const getFileFields = (type) => {
    const isCheckup = type === 'hcCheckupFile';
    return {
      fileNameField: isCheckup
        ? 'hcCheckupAttachmentFileName'
        : 'hcPostcareAttachmentFileName',
      saveNameField: isCheckup
        ? 'hcCheckupAttachmentSaveName'
        : 'hcPostcareAttachmentSaveName',
      filePathField: isCheckup
        ? 'hcCheckupAttachmentFilePath'
        : 'hcPostcareAttachmentFilePath',
      previewFilePathField: isCheckup
        ? 'hcCheckupPreviewFilePath'
        : 'hcPostcarePreviewFilePath',
      prefix: isCheckup ? 'hcCheckup' : 'hcPostcare',
    };
  };

  // 파일 타입별 핸들러 함수 반환 헬퍼 함수
  const getFileHandlers = (type) => {
    const isCheckup = type === 'checkup';
    return {
      deleteLogic: isCheckup ? DeleteLogicFileCheckup : DeleteLogicFilePostcare,
      saveLogic: isCheckup ? SaveLogicFileCheckup : SaveLogicFilePostcare,
    };
  };
  //#endregion

  //#region useEffect
  useEffect(() => {
    if (props.filterClick2) {
      gridRef1.current.api &&
        gridRef1.current.api.setQuickFilter(searchInfo.searchText || '');
      props.setFilterClick2(false);
    }
    if (props.saveClick2) {
      Save1();
      props.setSaveClick2(false);
    }
    if (props.printClick2) {
      if (!validateSelection()) {
        props.setPrintClick2(false);
        return;
      }
      PrintLogic1();
      props.setPrintClick2(false);
    }
    if (props.printClick2Guideline) {
      if (!validateSelection()) {
        props.setPrintClick2Guideline(false);
        return;
      }
      PrintGuidelineLogic();
      props.setPrintClick2Guideline(false);
    }
  }, [
    props.filterClick2,
    props.saveClick2,
    props.printClick2,
    props.printClick2Guideline,
  ]);
  //#endregion

  //#region 쿼리
  // 조회
  const { refetch: Search1 } = useSearch1({
    onSuccess: (rows) => {
      setRowData1(rows);
    },
  });
  const { runAsync: Search2Async } = useSearch2();

  // 삭제
  const delete1 = useDelete1();
  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRows,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });

  // 저장
  const { runAsync: Save1Async } = useSave1();
  const { runAsync: Save2Async } = useSave2();
  const { run: Save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel:
      '배치전/특수, 성명, 건강관리 구분, 소음/분진/야간작업/화학물질 취급 작업 체크, 검진주기, 검진일, 유효일자, 알람여부, 검진기관, 검진표 첨부, 사후관리조치 첨부',
    schema: HEA_BASIC_02_Schema,
    getChangedRows: () => changedRowData1.filter((r) => !r.deleteYn),
    getDeletedRows: () => deletedRows,
    requestDelete: deleteHandler1.DeleteLogic,
    requestSave: async (rows) => {
      // 1. 알람 처리 (Save2Async)
      const rowsWithAlarm = await Promise.all(
        rows.map(async (item) => {
          let alarmId = 0;
          try {
            // 캘린더 정보 조회
            const calendarData = await Search2Async();
            if (calendarData && calendarData.length > 0) {
              // mainCalendar = 'Y'인 것의 calId 찾기
              const mainCalendar = calendarData.find(
                (cal) => cal.mainCalendar === 'Y'
              );
              const calId = mainCalendar?.calId || null;
              if (calId) {
                // 알람 생성/삭제 처리
                const alarmResult = await Save2Async([{ ...item, calId }]);
                const alarmData = alarmResult?.data || [];
                if (alarmData && alarmData.length > 0) {
                  alarmId = alarmData[0]?.alarmId || null;
                }
              }
            }
          } catch (error) {
            console.error('알람 처리 중 오류:', error);
            // 알람 처리 실패해도 저장은 진행
          }
          return { ...item, alarmId };
        })
      );
      // 2. 저장 (Save1Async)
      return Save1Async(rowsWithAlarm);
    },
    fileDelete: async (deletedRows) => {
      // 삭제된 행들에 대해 파일 삭제 처리
      for (const item of deletedRows) {
        const fileTypes = [
          {
            type: 'checkup',
            oldFilePath: item.hcCheckupAttachmentFilePath || '',
          },
          {
            type: 'postcare',
            oldFilePath: item.hcPostcareAttachmentFilePath || '',
          },
        ];
        for (const fileType of fileTypes) {
          // 파일이 삭제된 경우
          if (fileType.oldFilePath) {
            const { deleteLogic } = getFileHandlers(fileType.type);
            await deleteLogic(fileType.oldFilePath);
          }
        }
      }
    },
    fileSave: async (changedRows) => {
      // 저장된 행들에 대해 파일 저장 처리
      for (const item of changedRows) {
        // 파일 처리 - 배열로 구성
        const fileTypes = [
          {
            type: 'checkup',
            fileName: item.hcCheckupAttachmentSaveName || '',
            oldFilePath: item.hcCheckupAttachmentFilePath || '',
            previewFilePath: item.hcCheckupPreviewFilePath || '',
          },
          {
            type: 'postcare',
            fileName: item.hcPostcareAttachmentSaveName || '',
            oldFilePath: item.hcPostcareAttachmentFilePath || '',
            previewFilePath: item.hcPostcarePreviewFilePath || '',
          },
        ];
        for (const fileType of fileTypes) {
          if (fileType.previewFilePath && fileType.fileName) {
            // 새 파일이 업로드된 경우
            const { prefix } = getFileFields(
              fileType.type === 'checkup' ? 'hcCheckupFile' : 'hcPostcareFile'
            );
            const { deleteLogic, saveLogic } = getFileHandlers(fileType.type);
            const fileData = {
              ...item,
              [`${prefix}AttachmentSaveName`]: fileType.fileName,
              [`${prefix}AttachmentFilePath`]: fileType.oldFilePath,
              previewFilePath: fileType.previewFilePath,
            };
            await deleteLogic(fileType.oldFilePath);
            await saveLogic(fileData, searchInfo.custCd);
          }
        }
      }
    },
    onSuccessRefresh: () => SearchLogic1(),
    partialRefresh: async ({ saveResult, changedRows }) => {
      await handlePartialRefresh({
        saveResult,
        changedRows,
        searchLogic: SearchLogic1,
      });
    },
  });

  const ResetLogic = () => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
    gridRef1?.current?.api?.deselectAll();
  };

  const SearchLogic1 = async () => {
    ResetLogic();
    if (!validateSelection()) return;
    await Search1();
  };
  //#endregion

  //#region 나머지 함수
  const DownloadLogic1 = async () => {
    try {
      let filePath = '';
      let fileName = previewFileName || 'downloaded_file';

      if (previewUrl) {
        if (previewUrl.startsWith('data:')) {
          const a = document.createElement('a');
          a.href = previewUrl;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          a.remove();
          dispatch(
            showSnackbar({
              message: `"${fileName}" 다운로드 완료`,
              type: 'success',
            })
          );
          return;
        }
        filePath = previewUrl.includes(Global.file.useUrl + 'files/')
          ? decodeURIComponent(
              previewUrl.replace(Global.file.useUrl + 'files/', '')
            )
          : previewUrl;
      } else {
        const rowData = selectedRowData1?.[0];
        if (!rowData) {
          dispatch(
            showSnackbar({
              message: '파일이 존재하지 않습니다.',
              type: 'warning',
            })
          );
          return;
        }
        const { filePathField, fileNameField, previewFilePathField } =
          getFileFields(currentFileFieldType);
        filePath =
          rowData[previewFilePathField] || rowData[filePathField] || '';
        fileName = rowData[fileNameField] || fileName;
        if (!filePath) {
          dispatch(
            showSnackbar({
              message: '파일이 존재하지 않습니다.',
              type: 'warning',
            })
          );
          return;
        }
      }

      const finalFileName =
        fileName === 'downloaded_file'
          ? decodeURIComponent(filePath.split('/').pop() || fileName)
          : fileName;

      const result = await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        { FileName: finalFileName, Url: Commons.EncodeUrl(filePath) }
      );

      if (!result?.data || !result?.headers?.['content-type']) {
        dispatch(
          showSnackbar({
            message: `"${finalFileName}" 다운로드 응답이 비정상입니다.`,
            type: 'error',
          })
        );
        return;
      }

      const blob = new Blob([result.data], {
        type: result.headers['content-type'],
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = finalFileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      dispatch(
        showSnackbar({
          message: `"${finalFileName}" 다운로드 완료`,
          type: 'success',
        })
      );
    } catch (error) {
      dispatch(showSnackbar({ message: error.message, type: 'error' }));
    }
  };

  // 인쇄 함수
  const PrintLogic1 = useCallback(async () => {
    // 데이터 확인
    const currentRowData = rowData1.filter((row) => !row.deleteYn);
    if (currentRowData.length === 0) {
      dispatch(
        showSnackbar({
          message: '인쇄할 데이터가 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    dispatch(showLoadingAction());

    try {
      // 사업장명 가져오기
      const custNm =
        searchInfo.custList?.find((item) => item.value === searchInfo.custCd)
          ?.name || '';

      // HeaderData 설정
      const headerData = {
        custNm: custNm, // 사업장명
        createDate: dayjs().format('YYYY-MM-DD'), // 작성일자
        userNm: userInfo.userNm || '', // 사용자명
      };

      // TableData 매핑 (레포트 양식에 맞게) - 최신 rowData1 사용
      const tableData = currentRowData.map((row, index) => {
        // 배치전/특수 변환
        const checkType =
          row.checkType === '0' ||
          row.checkType === 0 ||
          row.checkType === '배치전'
            ? '배치전'
            : row.checkType === '1' ||
                row.checkType === 1 ||
                row.checkType === '특수'
              ? '특수'
              : '';

        // workEnvironmentType 문자열을 파싱하여 텍스트로 변환
        // 0:소음, 1:분진, 2:야간작업, 3:화학물질
        const workEnvironmentTypeValue = row.workEnvironmentType || '';
        const workTypes = [];
        if (workEnvironmentTypeValue.includes('0')) {
          workTypes.push('소음');
        }
        if (workEnvironmentTypeValue.includes('1')) {
          workTypes.push('분진');
        }
        if (workEnvironmentTypeValue.includes('2')) {
          workTypes.push('야간');
        }
        if (workEnvironmentTypeValue.includes('3')) {
          workTypes.push('화학물질');
        }
        const workEnvironmentType = workTypes.join('/') || '';

        // 건강관리 구분 코드를 문자열로 변환
        const hscGubunCode = row.hscGubun || '';
        const hscGubunValueMap = {
          A: 'A(이상없음)',
          D1: 'D1 (직업병 유소견자)',
          D2: 'D2(일반질병 유소견자)',
          C1: 'C1(직업병 요관찰자)',
          C2: 'C2(일반질병 요관찰자)',
          R: 'R(재검)',
        };
        const hscGubunText = hscGubunValueMap[hscGubunCode] || hscGubunCode;

        // 검진일 포맷팅
        const checkupDate = row.hcDate
          ? dayjs(row.hcDate).format('YYYY-MM-DD')
          : '';

        // 유효일자 포맷팅
        const effeDate = row.hcEffeDate
          ? dayjs(row.hcEffeDate).format('YYYY-MM-DD')
          : '';

        return {
          no: index + 1,
          checkType: checkType, // 배치전/특수
          depNm1: row.depNm1 || '', // 본부
          depNm2: row.depNm2 || '', // 부서
          depNm3: row.depNm3 || '', // 팀
          depNm4: row.depNm4 || '', // 파트
          position: row.position || '', // 직책
          name: row.name || '', // 성명
          hscGubun: hscGubunText, // 건강관리 구분
          workEnvironmentType: workEnvironmentType, // 소음/분진/야간작업/화학물질 취급작업
          hcSubstance: row.hcSubstance || '', // 취급물질
          hcPost: row.hcPost || '', // 배치 후
          hcCycle: row.hcCycle || '', // 검진주기 (월)
          hcDate: checkupDate, // 검진일
          hcEffeDate: effeDate, // 유효일자
          hcAlarmYn: row.hcAlarmYn || '', // 알람여부(Y/N)
          hcCheckupCenter: row.hcCheckupCenter || '', // 검진기관
          hcRemark: row.hcRemark || '', // 비고
        };
      });

      const printData = {
        FileName: 'HEA_BASIC_02',
        HeaderData: JSON.stringify(headerData),
        TableData: JSON.stringify(tableData),
      };

      await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank'); // 새 탭에서 열기
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      dispatch(closeLoadingAction());
    }
  }, [rowData1, dispatch, searchInfo, userInfo.userNm]);

  // 건강진단 실시 지침서 인쇄 함수
  const PrintGuidelineLogic = useCallback(async () => {
    dispatch(showLoadingAction());
    try {
      const printData = {
        FileName: 'HEA_BASIC',
        HeaderData: JSON.stringify({}),
      };
      await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank'); // 새 탭에서 열기
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      dispatch(closeLoadingAction());
    }
  }, [dispatch]);

  const PopupFileClickEvent = async (rowData, fieldType) => {
    setCurrentFileFieldType(fieldType);
    const { previewFilePathField, fileNameField, filePathField } =
      getFileFields(fieldType);
    const newPreviewPath = rowData[previewFilePathField] || '';
    const newFileName = rowData[fileNameField] || '';
    const existingFilePath = rowData[filePathField] || '';
    const existingFileName = rowData[fileNameField] || '';
    const fileName = newFileName || existingFileName;
    let previewUrl = '';
    if (newPreviewPath) {
      const fixedPath = Commons.EncodeUrl(newPreviewPath);
      previewUrl = fixedPath ? Global.file.useUrl + 'files/' + fixedPath : '';
    } else if (existingFilePath) {
      const fixedPath = Commons.EncodeUrl(existingFilePath);
      previewUrl = fixedPath ? Global.file.useUrl + 'files/' + fixedPath : '';
    }
    dispatch(
      setFileFields({
        previewFilePathField,
        previewFileName: fileName || '파일 선택',
        previewUrl,
      })
    );
    setTimeout(() => setFileModalToggle(true), 100);
  };

  const PopupClickEvent1 = (e) => {
    rowClickData.current = {
      rowIndex: e.rowIndex,
      data: e.data,
    };
    setModalToggle1(true);
  };

  const updateGridRow = (rowNode, selected) => {
    const updatedData = {
      ...rowNode.data,
      hscId: selected.id,
      name: selected.name,
      depNm1: selected.depNm1,
      depNm2: selected.depNm2,
      depNm3: selected.depNm3,
      depNm4: selected.depNm4,
      position: selected.position,
      employeeNo: selected.employeeNo,
      editYn: 'Y',
    };
    rowNode.setData(updatedData);
    setChangedRowData1((prev) => {
      const filtered = prev.filter((row) => row.no !== updatedData.no);
      return [...filtered, updatedData];
    });
    const api = gridRef1.current?.api;
    if (api) {
      api.setFocusedCell(rowNode.rowIndex, 'name');
      api.startEditingCell({ rowIndex: rowNode.rowIndex, colKey: 'name' });
    }
  };

  const HandleManageSelection = (selected) => {
    if (!selected) return;

    const api = gridRef1.current?.api;
    if (!api) return;

    let rowIndex = rowClickData.current?.rowIndex;
    let rowNode = null;

    if (rowIndex === undefined) {
      const allNodes = [];
      api.forEachNode((node) => allNodes.push(node));
      const newRows = allNodes.filter((n) => n.data?.newYn === 'Y');
      const newRow = newRows[newRows.length - 1];
      if (newRow) {
        rowNode = newRow;
      }
    } else {
      rowNode = api.getDisplayedRowAtIndex(rowIndex);
    }

    if (!rowNode) {
      console.warn(
        'HandleManageSelection: 대상 행(rowNode)을 찾지 못했습니다. 100ms 후 재시도합니다.'
      );
      setTimeout(() => {
        const allNodes = [];
        api.forEachNode((node) => allNodes.push(node));
        const newRows = allNodes.filter((n) => n.data?.newYn === 'Y');
        const newRow = newRows[newRows.length - 1];
        if (newRow) {
          updateGridRow(newRow, selected);
        }
      }, 100);
      return;
    }

    updateGridRow(rowNode, selected);
    rowClickData.current = null;
  };

  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };

  const handleRowSelection1 = (rowData, rowIndex) => {
    currentRowIndexRef1.current = rowIndex;
    setSelectedRowData1([rowData]);
  };

  // 엑셀 업로드
  const ExcelUpload1 = async (file) => {
    try {
      dispatch(showLoadingAction());

      const arrayBuffer = await file.arrayBuffer();
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);

      const worksheet = workbook.worksheets[0];
      if (!worksheet) {
        dispatch(
          showSnackbar({
            message: '엑셀 시트를 불러오지 못했습니다.',
            type: 'warning',
          })
        );
        dispatch(closeLoadingAction());
        return;
      }

      // 6행부터 데이터 읽기
      const startRow = 7;
      // 소음/분진/야간/화학물질은 엑셀에서 4개 컬럼(Y/N)으로 표현
      const columnKeys = [
        'checkType',
        'depNm1',
        'depNm2',
        'depNm3',
        'depNm4',
        'position',
        'name',
        'employeeNo',
        'hscGubun',
        'noiseYn',
        'dustYn',
        'nightYn',
        'chemicalYn',
        'hcSubstance',
        'hcPost',
        'hcCycle',
        'hcDate',
        'hcEffeDate',
        'hcAlarmYn',
        'hcCheckupCenter',
        'hcRemark',
      ];

      // Y/N 또는 체크표시(✓) → Y/N 정규화 (POL_BASIC_02 planQuarter 방식)
      const normalizeYn = (v) => {
        if (v == null || v === '') return 'N';
        const s = String(v).trim();
        if (
          s === '✓' ||
          s.toUpperCase() === 'Y' ||
          s === 'O' ||
          s === '1' ||
          s.toUpperCase() === 'TRUE'
        )
          return 'Y';
        return 'N';
      };

      // 건강관리 구분: 표시 문자열 "A(이상없음)" 등 → 코드 "A" 로 정규화 (업로드/비교용)
      const hscGubunToCode = (v) => {
        if (v == null || v === '') return '';
        const s = String(v).trim();
        const codeList = ['A', 'D1', 'D2', 'C1', 'C2', 'R'];
        if (codeList.includes(s)) return s;
        const codeMatch = s.match(/^([ADC12R]+)/);
        return codeMatch ? codeMatch[1] : s;
      };

      const uploadedData = [];
      let currentRow = startRow;
      let hasData = true;

      while (hasData) {
        const row = worksheet.getRow(currentRow);
        const rowData = {};

        // 첫 번째 컬럼(배치전/특수) 또는 성명(7번째)이 비어있으면 데이터가 없는 것으로 간주
        const nameCellValue = row.getCell(7).value;
        if (!nameCellValue || nameCellValue.toString().trim() === '') {
          hasData = false;
          break;
        }

        columnKeys.forEach((key, index) => {
          const cell = row.getCell(index + 1);
          let value = cell.value;

          if (value === null || value === undefined) {
            value = '';
          } else {
            if (key === 'hcDate' || key === 'hcEffeDate') {
              if (value instanceof Date) {
                value = value.toISOString();
              } else if (typeof value === 'number') {
                const excelDate = new Date((value - 25569) * 86400 * 1000);
                value = excelDate.toISOString();
              } else {
                value = value.toString().trim();
              }
            } else if (key === 'checkType') {
              const str = value.toString().trim();
              if (str === '배치전' || str === '0') value = '0';
              else if (str === '특수' || str === '1') value = '1';
              else value = str || '0';
            } else if (
              key === 'noiseYn' ||
              key === 'dustYn' ||
              key === 'nightYn' ||
              key === 'chemicalYn'
            ) {
              value = normalizeYn(value);
            } else {
              if (typeof value === 'object' && value !== null) {
                value =
                  Array.isArray(value.richText) && value.richText.length > 0
                    ? value.richText.map((item) => item?.text || '').join('')
                    : value.toString().trim();
              } else {
                value = value.toString().trim();
              }
            }
          }

          rowData[key] = value;
        });

        // 4개 Y/N 컬럼을 workEnvironmentType 문자열로 합침 (0:소음, 1:분진, 2:야간, 3:화학물질)
        const parts = [];
        if (rowData.noiseYn === 'Y') parts.push('0');
        if (rowData.dustYn === 'Y') parts.push('1');
        if (rowData.nightYn === 'Y') parts.push('2');
        if (rowData.chemicalYn === 'Y') parts.push('3');
        rowData.workEnvironmentType = parts.join(',');

        // 건강관리 구분: 엑셀 표시 문자열 → 코드로 정규화 (다운로드 후 수정 없이 업로드 시 동일값 비교되도록)
        rowData.hscGubun = hscGubunToCode(rowData.hscGubun || '');

        if (rowData.name) {
          rowData.newYn = 'Y';
          rowData.no = `new_${Date.now()}_${currentRow}`;
          rowData.hscId = companyInfo[0].properName + rowData.employeeNo;
          uploadedData.push(rowData);
        }

        currentRow++;
        if (currentRow > startRow + 1000) {
          break;
        }
      }

      if (uploadedData.length === 0) {
        dispatch(
          showSnackbar({
            message: '읽을 수 있는 데이터가 없습니다.',
            type: 'warning',
          })
        );
        dispatch(closeLoadingAction());
        return;
      }

      // 엑셀 업로드 키: 본부, 부서, 팀, 파트, 직책, 성명
      const makeKeyString = (item) => {
        const depNm1 = item.depNm1 != null ? String(item.depNm1).trim() : '';
        const depNm2 = item.depNm2 != null ? String(item.depNm2).trim() : '';
        const depNm3 = item.depNm3 != null ? String(item.depNm3).trim() : '';
        const depNm4 = item.depNm4 != null ? String(item.depNm4).trim() : '';
        const position =
          item.position != null ? String(item.position).trim() : '';
        const name = item.name != null ? String(item.name).trim() : '';
        return `${depNm1}|${depNm2}|${depNm3}|${depNm4}|${position}|${name}`;
      };

      const existingDataMap = new Map();
      rowData1.forEach((row) => {
        if (!row.deleteYn) {
          const key = makeKeyString(row);
          if (key && key !== '|||||') existingDataMap.set(key, row);
        }
      });

      const excelKeySet = new Set();
      uploadedData.forEach((row) => {
        const key = makeKeyString(row);
        if (key && key !== '|||||') excelKeySet.add(key);
      });

      const workTypeToYn = (workStr, code) =>
        (workStr || '').includes(code) ? 'Y' : 'N';

      const hasChanges = (existingRow, excelRow) => {
        const fieldsToCompare = columnKeys.filter((k) => k !== 'name');
        for (const field of fieldsToCompare) {
          let existingValue = existingRow[field];
          let excelValue = excelRow[field];

          if (
            field === 'noiseYn' ||
            field === 'dustYn' ||
            field === 'nightYn' ||
            field === 'chemicalYn'
          ) {
            const code = {
              noiseYn: '0',
              dustYn: '1',
              nightYn: '2',
              chemicalYn: '3',
            }[field];
            existingValue = workTypeToYn(existingRow.workEnvironmentType, code);
            excelValue = excelValue != null ? String(excelValue).trim() : 'N';
          } else if (field === 'hcDate' || field === 'hcEffeDate') {
            existingValue = existingValue
              ? dayjs(existingValue).isValid()
                ? dayjs(existingValue).format('YYYY-MM-DD')
                : String(existingValue || '').trim()
              : '';
            excelValue = excelValue
              ? dayjs(excelValue).isValid()
                ? dayjs(excelValue).format('YYYY-MM-DD')
                : String(excelValue || '').trim()
              : '';
          } else {
            existingValue =
              existingValue != null ? String(existingValue).trim() : '';
            excelValue = excelValue != null ? String(excelValue).trim() : '';
          }

          if (existingValue !== excelValue) return true;
        }
        return false;
      };

      const newRows = [];
      const updatedRows = [];
      const updatedKeys = new Set();

      for (const excelRow of uploadedData) {
        const key = makeKeyString(excelRow);
        if (!key || key === '|||||') continue; // 본부~성명 모두 비어있으면 스킵

        if (existingDataMap.has(key)) {
          const existingRow = existingDataMap.get(key);
          if (hasChanges(existingRow, excelRow)) {
            const updatedRow = {
              ...existingRow,
              ...excelRow,
              editYn: 'Y',
              no: existingRow.no,
              hscCd: existingRow.hscCd || '',
            };
            updatedRows.push(updatedRow);
            updatedKeys.add(key);
          }
        } else {
          newRows.push({
            ...excelRow,
            newYn: 'Y',
            no: `new_${Date.now()}_${Math.random()}`,
          });
        }
      }

      const rowsToDelete = [];
      rowData1.forEach((row) => {
        if (!row.deleteYn) {
          const key = makeKeyString(row);
          if (
            key &&
            key !== '|||||' &&
            !excelKeySet.has(key) &&
            row.deleteYn !== 'Y'
          ) {
            rowsToDelete.push({ ...row, deleteYn: 'Y' });
          }
        }
      });

      const updatedRowData = rowData1.map((row) => {
        if (row.deleteYn) return row;
        const key = makeKeyString(row);
        if (key && updatedKeys.has(key)) {
          const updatedRow = updatedRows.find(
            (ur) => makeKeyString(ur) === key
          );
          if (updatedRow) return updatedRow;
        }
        if (rowsToDelete.some((rd) => rd.no === row.no)) {
          return { ...row, deleteYn: 'Y' };
        }
        return row;
      });

      const finalRowData = [...updatedRowData, ...newRows];
      setRowData1(finalRowData);
      gridRef1.current.api.setRowData(finalRowData);

      const changedData = [...updatedRows, ...newRows];
      setChangedRowData1(changedData);

      if (rowsToDelete.length > 0) {
        setDeletedRowData1((prev) => {
          const existingDeleted = prev || [];
          const newDeleted = rowsToDelete.filter(
            (rd) => !existingDeleted.some((ed) => ed.no === rd.no)
          );
          return [...existingDeleted, ...newDeleted];
        });
      }

      dispatch(
        showSnackbar({
          message: '엑셀 업로드가 완료되었습니다.',
          type: 'success',
        })
      );
    } catch (error) {
      console.error('Excel upload error:', error);
      dispatch(
        showSnackbar({
          message: `엑셀 업로드 중 오류가 발생했습니다: ${error.message}`,
          type: 'error',
        })
      );
    } finally {
      dispatch(closeLoadingAction());
    }
  };

  // 엑셀 다운로드
  const ExcelDownload1 = async () => {
    try {
      dispatch(showLoadingAction());

      const workbook = new ExcelJS.Workbook();
      const templateUrl = getTemplatePath();

      const response = await fetch(templateUrl);
      const arrayBuffer = await response.arrayBuffer();
      await workbook.xlsx.load(arrayBuffer);

      const worksheet = workbook.worksheets[0];
      if (!worksheet) {
        dispatch(
          showSnackbar({
            message: '템플릿 시트를 불러오지 못했습니다.',
            type: 'warning',
          })
        );
        dispatch(closeLoadingAction());
        return false;
      }

      const detailData = rowData1.filter((r) => !r.deleteYn);
      const startRow = 7;
      const columnKeys = [
        'checkType',
        'depNm1',
        'depNm2',
        'depNm3',
        'depNm4',
        'position',
        'name',
        'employeeNo',
        'hscGubun',
        'noiseYn',
        'dustYn',
        'nightYn',
        'chemicalYn',
        'hcSubstance',
        'hcPost',
        'hcCycle',
        'hcDate',
        'hcEffeDate',
        'hcAlarmYn',
        'hcCheckupCenter',
        'hcRemark',
      ];

      const workEnvToYn = (workStr, code) =>
        (workStr || '').includes(code) ? 'Y' : 'N';

      // 건강관리 구분: 코드(A, D1, ...) → 드롭다운 표시 문자열
      const hscGubunDisplayMap = {
        A: 'A(이상없음)',
        D1: 'D1 (직업병 유소견자)',
        D2: 'D2(일반질병 유소견자)',
        C1: 'C1(직업병 요관찰자)',
        C2: 'C2(일반질병 요관찰자)',
        R: 'R(재검)',
      };

      detailData.forEach((item, index) => {
        const row = worksheet.getRow(startRow + index);
        columnKeys.forEach((key, i) => {
          const cell = row.getCell(i + 1);

          let value;
          if (key === 'noiseYn')
            value = workEnvToYn(item.workEnvironmentType, '0');
          else if (key === 'dustYn')
            value = workEnvToYn(item.workEnvironmentType, '1');
          else if (key === 'nightYn')
            value = workEnvToYn(item.workEnvironmentType, '2');
          else if (key === 'chemicalYn')
            value = workEnvToYn(item.workEnvironmentType, '3');
          else value = item[key];

          if (key === 'hcDate' || key === 'hcEffeDate') {
            if (value) {
              const date = dayjs(value);
              value = date.isValid() ? date.format('YYYY-MM-DD') : '';
            } else {
              value = '';
            }
            cell.numFmt = '@';
          } else if (key === 'checkType') {
            value =
              value === '0' || value === 0
                ? '배치전'
                : value === '1' || value === 1
                  ? '특수'
                  : value || '';
          } else if (key === 'hscGubun') {
            // 건강관리 구분: 코드 → 드롭다운에 지정한 표시 문자열로 출력
            const code = value != null ? String(value).trim() : '';
            value = hscGubunDisplayMap[code] || code || '';
          } else if (
            key === 'noiseYn' ||
            key === 'dustYn' ||
            key === 'nightYn' ||
            key === 'chemicalYn'
          ) {
            // Y/N을 체크표시(✓)로 출력 (POL_BASIC_02 planQuarter 방식)
            value = value === 'Y' ? '✓' : '';
          } else {
            value = value != null ? String(value) : '';
          }

          setPreserveStyle(cell, value);

          const isWorkEnvCol =
            key === 'noiseYn' ||
            key === 'dustYn' ||
            key === 'nightYn' ||
            key === 'chemicalYn';
          cell.font = { name: 'Arial', size: 10 };
          cell.alignment = {
            vertical: 'middle',
            horizontal: isWorkEnvCol ? 'center' : 'left',
            wrapText: false,
          };
          cell.border = {
            top: { style: 'thin', color: { argb: 'FF808080' } },
            left: { style: 'thin', color: { argb: 'FF808080' } },
            bottom: { style: 'thin', color: { argb: 'FF808080' } },
            right: { style: 'thin', color: { argb: 'FF808080' } },
          };
        });
        row.commit();
      });

      const maxDataRow = Math.max(startRow + detailData.length, startRow + 200);
      const endRow = maxDataRow;

      // 알람여부 컬럼 드롭다운
      const alarmYnColIndex = columnKeys.indexOf('hcAlarmYn');
      if (alarmYnColIndex !== -1) {
        const alarmYnCol = String.fromCharCode(65 + alarmYnColIndex);
        worksheet.dataValidations.add(
          `${alarmYnCol}${startRow}:${alarmYnCol}${endRow}`,
          {
            type: 'list',
            allowBlank: true,
            formulae: ['"Y,N"'],
            showErrorMessage: true,
            errorStyle: 'error',
            errorTitle: '입력 오류',
            error: 'Y 또는 N만 입력 가능합니다.',
          }
        );
      }

      // 검진주기 컬럼 드롭다운 (6달, 12달, 24달, 36달)
      const hcCycleColIndex = columnKeys.indexOf('hcCycle');
      if (hcCycleColIndex !== -1) {
        const hcCycleCol = String.fromCharCode(65 + hcCycleColIndex);
        worksheet.dataValidations.add(
          `${hcCycleCol}${startRow}:${hcCycleCol}${endRow}`,
          {
            type: 'list',
            allowBlank: true,
            formulae: ['"6달,12달,24달,36달"'],
            showErrorMessage: true,
            errorStyle: 'error',
            errorTitle: '입력 오류',
            error: '6달, 12달, 24달, 36달 중에서 선택해주세요.',
          }
        );
      }

      // 배치전/특수 컬럼 드롭다운
      const checkTypeColIndex = columnKeys.indexOf('checkType');
      if (checkTypeColIndex !== -1) {
        const checkTypeCol = String.fromCharCode(65 + checkTypeColIndex);
        worksheet.dataValidations.add(
          `${checkTypeCol}${startRow}:${checkTypeCol}${endRow}`,
          {
            type: 'list',
            allowBlank: true,
            formulae: ['"배치전,특수"'],
            showErrorMessage: true,
            errorStyle: 'error',
            errorTitle: '입력 오류',
            error: '배치전 또는 특수만 입력 가능합니다.',
          }
        );
      }

      // 건강관리 구분 컬럼 드롭다운
      const hscGubunColIndex = columnKeys.indexOf('hscGubun');
      if (hscGubunColIndex !== -1) {
        const hscGubunCol = String.fromCharCode(65 + hscGubunColIndex);
        const hscGubunList =
          'A(이상없음),D1 (직업병 유소견자),D2(일반질병 유소견자),C1(직업병 요관찰자),C2(일반질병 요관찰자),R(재검)';
        worksheet.dataValidations.add(
          `${hscGubunCol}${startRow}:${hscGubunCol}${endRow}`,
          {
            type: 'list',
            allowBlank: true,
            formulae: [`"${hscGubunList}"`],
            showErrorMessage: true,
            errorStyle: 'error',
            errorTitle: '입력 오류',
            error: '건강관리 구분 목록에서 선택해주세요.',
          }
        );
      }

      // 직책 컬럼 드롭다운 (9종)
      const positionColIndex = columnKeys.indexOf('position');
      if (positionColIndex !== -1) {
        const positionCol = String.fromCharCode(65 + positionColIndex);
        const positionList =
          '사업주,안전관리자,보건관리자,관리감독자,산업보건의,안전보건관리담당자,안전보건총괄책임자,안전보건관리책임자,명예산업안전감독관';
        worksheet.dataValidations.add(
          `${positionCol}${startRow}:${positionCol}${endRow}`,
          {
            type: 'list',
            allowBlank: true,
            formulae: [`"${positionList}"`],
            showErrorMessage: true,
            errorStyle: 'error',
            errorTitle: '입력 오류',
            error: '직책 목록에서 선택해주세요.',
          }
        );
      }

      // 소음/분진/야간작업/화학물질 컬럼 드롭다운 (✓ 또는 빈값 - POL_BASIC_02 planQuarter 방식)
      ['noiseYn', 'dustYn', 'nightYn', 'chemicalYn'].forEach((key) => {
        const colIndex = columnKeys.indexOf(key);
        if (colIndex !== -1) {
          const colLetter = String.fromCharCode(65 + colIndex);
          worksheet.dataValidations.add(
            `${colLetter}${startRow}:${colLetter}${endRow}`,
            {
              type: 'list',
              allowBlank: true,
              formulae: ['"✓,"'], // ✓ 또는 빈값 선택 가능
              showErrorMessage: true,
              errorStyle: 'error',
              errorTitle: '입력 오류',
              error: '✓ 또는 빈값만 입력 가능합니다.',
            }
          );
        }
      });

      // 날짜 컬럼 YYYY-MM-DD 형식 검증
      const dateFields = ['hcDate', 'hcEffeDate'];
      dateFields.forEach((dateField) => {
        const dateFieldColIndex = columnKeys.indexOf(dateField);
        if (dateFieldColIndex !== -1) {
          const colNumber = dateFieldColIndex + 1;
          const column = worksheet.getColumn(colNumber);
          column.numFmt = '@';
          const dateFieldCol = column.letter;
          worksheet.dataValidations.add(
            `${dateFieldCol}${startRow}:${dateFieldCol}${endRow}`,
            {
              type: 'custom',
              allowBlank: true,
              formulae: [
                `OR(${dateFieldCol}${startRow}="", AND(LEN(${dateFieldCol}${startRow})=10, MID(${dateFieldCol}${startRow},5,1)="-", MID(${dateFieldCol}${startRow},8,1)="-"))`,
              ],
              showErrorMessage: true,
              errorStyle: 'error',
              errorTitle: '입력 오류',
              error:
                '날짜는 YYYY-MM-DD 형식으로 입력해주세요. (예: 2025-01-15)',
            }
          );
        }
      });

      const dateTimeStr = getCurrentFormattedDateTime('file');
      const methodName = `특수건강진단_${dateTimeStr}.xlsx`;

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = methodName;
      link.click();

      dispatch(closeLoadingAction());
    } catch (error) {
      console.error('Excel download error:', error);
      dispatch(
        showSnackbar({
          message: `엑셀 다운로드 중 오류가 발생했습니다: ${error.message}`,
          type: 'error',
        })
      );
      dispatch(closeLoadingAction());
    }
  };

  function setPreserveStyle(cell, value) {
    if (!cell) return;
    const { font, alignment, border, fill, numFmt } = cell;
    cell.value = value;
    cell.style = { font, alignment, border, fill, numFmt };
  }

  function getTemplatePath() {
    const base = `${Global.file.useUrl}files/ExcellExportFrom/HealthCheckup/`;
    return base + '특수건강진단.xlsx';
  }

  function getCurrentFormattedDateTime(_type) {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    if (_type === 'data') {
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    } else if (_type === 'file') {
      return `${year}${month}${day}_${hours}${minutes}${seconds}`;
    }
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  //#endregion

  return (
    <div className="wrap">
      <HEA_BASIC_02
        gridId1={'grid1'}
        navigate={navigate}
        userInfo={userInfo}
        rowData1={rowData1}
        lanInfo={lanInfo}
        gridRef1={gridRef1}
        gridRef3={gridRef3}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        deletedRowData1={deletedRows}
        selectedRowNosRef1={selectedRowNosRef1}
        lastCheckedIndexRef1={lastCheckedIndexRef1}
        modalToggle1={modalToggle1}
        setModalToggle1={setModalToggle1}
        rowClickData={rowClickData}
        excelData={excelData}
        setExcelData={setExcelData}
        fileInputRef={fileInputRef}
        dispatch={dispatch}
        showSnackbar={showSnackbar}
        handleCoChange={handleCoChange}
        handleCustChange={handleCustChange}
        validateSelection={validateSelection}
        searchInfo={searchInfo}
        ResetLogic1={ResetLogic}
        SearchLogic1={SearchLogic1}
        PopupClickEvent1={PopupClickEvent1}
        SaveLogic1={Save1}
        DownloadLogic1={DownloadLogic1}
        NewYnErrorMsg={NewYnErrorMsg}
        handleRowSelection1={handleRowSelection1}
        RestoreRow1={deleteHandler1.RestoreRow}
        MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
        DeleteNewRow1={deleteHandler1.DeleteNewRow}
        HandleManageSelection={HandleManageSelection}
        fileModalToggle={fileModalToggle}
        currentFileFieldType={currentFileFieldType}
        setCurrentFileFieldType={setCurrentFileFieldType}
        setFileModalToggle={setFileModalToggle}
        PopupFileClickEvent={PopupFileClickEvent}
        SaveLogicPreview={SaveLogicPreview}
        DeleteLogicFile={DeleteLogicFile}
        ExcelUpload1={ExcelUpload1}
        ExcelDownload1={ExcelDownload1}
      />
      <MemberInfoModal
        open={modalToggle1}
        onClose={() => setModalToggle1(false)}
        onSelection={HandleManageSelection}
      />
    </div>
  );
}

export default HEA_BASIC_02F;
